import React from "react";
import styles from "../component/custom.module.css";

const Footer = () => {
  return (
    <div className={styles.footerNew_section}>
      <div className="container">
        <p>
          For any registration related queries, please contact:{" "}
          <a href="mailto: customercare@vedistry.com">
            customercare@vedistry.com
          </a>{" "}
          or call us on{" "}
          <a style={{ cursor: "pointer" }} href="tel: +91 8657451582">
            +91 8657451582
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
